import { z } from "zod";

export const MintNativeScriptToken$Params = z.object({
  artworkId: z.string(),
  address: z.string(),
  utxosCBOR: z.string().array(), // CBOR Hex
});
export type MintNativeScriptToken$Params = z.infer<
  typeof MintNativeScriptToken$Params
>;

export const MintNativeScriptToken$Result = z.object({
  tx: z.string(), // CBOR Hex
});
export type MintNativeScriptToken$Result = z.infer<
  typeof MintNativeScriptToken$Result
>;
